import React, { useState, useEffect } from "react";
import { ThreeCircles } from "react-loader-spinner";
import "./ChefAddMenuModal.css";
import ItemDetails from "./ItemDetails";
import ItemCategory from "./ItemCategory";
import ItemAvailability from "./ItemAvailability";
import ItemPrice from "./ItemPrice";
import ItemImage from "./ItemImages";
import GetAPI from "../../APICalls/GetAPI";
import { v4 as uuidv4 } from "uuid";
import PostAPI from "../../APICalls/PostAPI";

const ChefAddMenuModal = ({ showAdd, handleAddClose, selectedChefData }) => {
  const [itemDetails, setItemDetails] = useState({ name: "", description: "" });
  const [itemCategory, setItemCategory] = useState(selectedChefData.isXpress
    ? {
        category: "",
        forCategories: [],
        menuCategory: [],
        foodType: { imageUrl: "", title: "", value: "" },
        foodStyle: "",
      }
    : {
        menuCategory: [],
        foodType: { imageUrl: "", title: "", value: "" },
        foodStyle: "",
      });
  const [itemAvailability, setItemAvailability] = useState(() => {
    return {
      isPreOrder: false,
      itemForever: false,
      menuTypes: [],
      isAllDaySelected: false,
      availabilityPlatform: "Homeal App",
      ...(selectedChefData.isXpress ? {} : { orderBy: "" })
    };
  });
  const [itemPrice, setItemPrice] = useState({ chefPrice: 0, itemPrice: 0, chefDiscount: 0 });
  const [itemImage, setItemImage] = useState("N/A");
  const [currentStep, setCurrentStep] = useState("Item Details");
  const [loading, setLoading] = useState(false);
  const [foodstyles, setFoodStyles] = useState([]);
  const [menuCategories, setMenuCategories] = useState([]);
  const [podCategories, setPodCategories] = useState([]);
  const [menuData, setMenuData] = useState("");

  const ENVIRONMENT = process.env.REACT_APP_NODE_ENV;
  let utilityApi, menuAPI;
  if (ENVIRONMENT?.toUpperCase() === "PRODUCTION") {
    utilityApi = process.env.REACT_APP_PROD_UTILITY;
    menuAPI = process.env.REACT_APP_PROD_CHEFMENU;
  } else {
    utilityApi = process.env.REACT_APP_DEV_UTILITY;
    menuAPI = process.env.REACT_APP_DEV_CHEFMENU;
  }

  useEffect(() => {
    const COMPLETE_UTILITY_URL = utilityApi + "?type=ALL";
    GetAPI(COMPLETE_UTILITY_URL)
      .then((res) => {
        if (res.data.statusCode === 200) {
          setFoodStyles(res.data.body[1].value);
          setMenuCategories(res.data.body[2].value);
          setPodCategories(res.data.body[23].value);
          setLoading(false);
        } else {
          console.log("Error occurred. Error =" + res);
          setLoading(false);
          alert("Failed to get utility ");
        }
      })
      .catch((e) => {
        console.log("Error occurred. Error =" + e);
        setLoading(false);
        alert("Failed to get utility ");
      });
  }, []);

  const handleSubmit = () => {
    if (itemDetails.name == "" || itemDetails.description == "") {
      alert("Please enter item name and description");
      setCurrentStep("Item Details");
      return;
    }
    const categoryCondition = selectedChefData.isXpress ? itemCategory?.category === "" : itemCategory?.menuCategory?.length === 0
    if (
      categoryCondition || itemCategory.foodStyle === "" || itemCategory.foodType.value === ""
    ) {
      alert("Please fill all fields");
      setCurrentStep("Item Category");
      return;
    }
    if (
      selectedChefData.isXpress && itemCategory.category.toUpperCase() === "ADD ONS" && itemCategory.forCategories.length == 0
    ) {
      alert("Please add for categories");
      setCurrentStep("Item Category");
      return;
    }

    if (itemAvailability?.menuTypes?.length === 0) {
      alert("Please fill all fields");
      setCurrentStep("Item Availability");
      return;
    }
    if (parseInt(itemPrice.chefDiscount) >= parseInt(itemPrice.chefPrice)) {
      alert("Price should be greater than discount");
      return;
    }
    setLoading(true);
    let dataToPost = {
      userID: selectedChefData.userID,
      itemID: uuidv4(),
      itemName: itemDetails.name,
      itemDescription: itemDetails.description,
      itemType: itemCategory.foodType.value,
      menuTags: itemCategory.foodStyle.split(","),
      menuCategories: itemCategory.menuCategory,
      menuType: itemAvailability.menuTypes,
      isPreOrder: itemAvailability.isPreOrder,
      itemForever: itemAvailability.itemForever,
      chefCost: itemPrice.chefPrice.toString(),
      imageUrl: "N/A",
      isHomealItem: false,
      appVersion: 332,
      isSaas:
        selectedChefData.saasUser &&
        itemAvailability.availabilityPlatform?.toUpperCase() === "SAAS WEBSITE",
      isBoth:
        selectedChefData.saasUser &&
        itemAvailability.availabilityPlatform?.toUpperCase() === "BOTH",
    };

    if(selectedChefData.isXpress){
      dataToPost["isXpress"] = true;
      dataToPost["category"] = itemCategory.category;
      dataToPost["forCategories"] = itemCategory.forCategories;
      dataToPost["itemPrice"] = itemPrice.itemPrice;
    } else {
      dataToPost["chefDiscount"] = itemPrice.chefDiscount;
      dataToPost["orderBy"] = itemAvailability.orderBy;
    }

    PostAPI(menuAPI, dataToPost)
      .then((res) => {
        if (res.data.statusCode === 201) {
          setMenuData(res.data.body)
          alert("Successfully added menu!!! ");
          goToNextStep("Item Price")
        } else {
          alert("Failed to add menu!!! ");
          console.log(res);
        }
        setLoading(false);
      })
      .catch((e) => {
        alert("Failed to add menu!!! ");
        console.log(e);
        setLoading(false);
      });
  };

  const goToNextStep = (step) => {
    const currentIndex = STEPS.findIndex((s) => s?.id.toUpperCase() === step.toUpperCase());
    if (currentIndex !== -1 && currentIndex < STEPS.length - 1) {
      setCurrentStep(STEPS[currentIndex + 1].id);
    }
  };

  const goBackToPreviousStep = () => {
    const currentIndex = STEPS.findIndex((s) => s?.id.toUpperCase() === currentStep?.toUpperCase());
    if (currentIndex > 0) {
      setCurrentStep(STEPS[currentIndex - 1].id);
    }
  };

  const handleDiscard = () => {
    const stepsToGoBack = [
      "ITEM CATEGORY",
      "ITEM AVAILABILITY",
      "ITEM PRICE",
      "ITEM IMAGE"
      ];
      
      if (currentStep.toUpperCase() === "ITEM DETAILS") {
      handleAddClose();
      } else if (stepsToGoBack.includes(currentStep.toUpperCase())) {
      goBackToPreviousStep();
      }
  };

  const STEPS = [
    {
      id: "Item Details",
      component: (
        <ItemDetails
          data={itemDetails}
          onChange={setItemDetails}
          onNext={() => goToNextStep("Item Details")}
          onDiscard={handleDiscard}
        />
      ),
    },
    {
      id: "Item Category",
      component: (
        <ItemCategory
          data={itemCategory}
          onChange={setItemCategory}
          foodstyles={foodstyles}
          menuCategories={menuCategories}
          podCategories={podCategories}
          xpressChef={selectedChefData.isXpress}
          onNext={() => goToNextStep("Item Category")}
          onDiscard={handleDiscard}
        />
      ),
    },
    {
      id: "Item Availability",
      component: (
        <ItemAvailability
          data={itemAvailability}
          onChange={setItemAvailability}
          saasUser={selectedChefData.saasUser}
          xpressChef={selectedChefData.isXpress}
          onNext={() => goToNextStep("Item Availability")}
          onDiscard={handleDiscard}
        />
      ),
    },
    {
      id: "Item Price",
      component: (
        <ItemPrice
          data={itemPrice}
          onChange={setItemPrice}
          onSubmit={handleSubmit}
          onDiscard={handleDiscard}
          xpressChef={selectedChefData.isXpress}
        />
      ),
    },
    {
      id: "Item Image",
      component: (
        <ItemImage
          data={itemImage}
          onChange={setItemImage}
          chefID={selectedChefData.userID}
          menuData={menuData}
          onDiscard={handleDiscard}
          handleAddClose={handleAddClose}
        />
      ),
    },
  ];

  const RenderProgress = ({ title, isActive }) => (
    <div className={`progress-item ${isActive ? "active" : ""}`} onClick={() => setCurrentStep(title) }>
      <p>{title}</p>
      {isActive && <div className="progress-bar-active"></div>}
    </div>
  );

  return (
    <div
      className={`modal fade ${showAdd ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ display: showAdd ? "block" : "none" }}
    >
       <div className="modal-dialog" role="document">
        <div className="modal-content">
          {loading && (
            <div className="spinnerContainer">
              <div className="spinner">
                <ThreeCircles
                  color="blue"
                  height={110}
                  width={110}
                  ariaLabel="three-circles-rotating"
                />
              </div>
            </div>
          )}
          <div className="modal-header">
            <h5
              className="modal-title"
              style={{ color: "black", fontSize: "1.25rem" }}
            >{`Add a new item`}</h5>
            <button type="button" className="close" onClick={handleAddClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="progress-bar-container">
              {STEPS.map((step) => (
                <RenderProgress
                  key={step.id}
                  title={step.id}
                  isActive={currentStep?.toUpperCase() === step?.id?.toUpperCase()}
                />
              ))}
            </div>
            {STEPS.find((s) => s?.id.toUpperCase() === currentStep.toUpperCase()).component}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChefAddMenuModal;
